const isIe = (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1);

export default ({ device: { width } }) => !isIe && width >= 850;
